var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#826DD4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 16.0999C17.0929 16.0999 19.6001 13.5927 19.6001 10.4999C19.6001 7.40711 17.0929 4.8999 14.0001 4.8999C10.9073 4.8999 8.4001 7.40711 8.4001 10.4999C8.4001 13.5927 10.9073 16.0999 14.0001 16.0999Z",
    fill: "#D7C3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 18.8999C9.99361 18.8999 6.54866 21.3041 5.0293 24.7486C7.45872 26.7784 10.5868 27.9999 14.0001 27.9999C17.4134 27.9999 20.5415 26.7784 22.9709 24.7486C21.4516 21.3041 18.0066 18.8999 14.0001 18.8999Z",
    fill: "#D7C3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.5e5c5363369b784df7ce442d7a58e930.svg";
export { ForwardRef as ReactComponent };